import React from 'react'
import { SvgIcon, SvgIconProps, useTheme } from '@mui/material'

const InfoIcon = (props: SvgIconProps) => {
  // @ts-ignore
  const { color, fill, stroke, sx, width, height, ...otherProps } = props // eslint-disable-line
  const theme = useTheme()

  let selectedColor = color

  // @ts-ignore
  if (color && theme.palette[color]) {
    // @ts-ignore
    selectedColor = theme.palette[color].main
  }

  const fillStyle = fill || selectedColor || undefined

  const styles = {
    width: 'inherit',
    height: 'inherit',
    fill: 'inherit',
    ...sx,
  }

  const cleanedPaths = () => (
    <svg
      width={width || 12}
      height={height || 12}
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M6 0C2.68661 0 0 2.68661 0 6C0 9.31339 2.68661 12 6 12C9.31339 12 12 9.31339 12 6C12 2.68661 9.31339 0 6 0ZM6.42857 8.89286C6.42857 8.95179 6.38036 9 6.32143 9H5.67857C5.61964 9 5.57143 8.95179 5.57143 8.89286V5.25C5.57143 5.19107 5.61964 5.14286 5.67857 5.14286H6.32143C6.38036 5.14286 6.42857 5.19107 6.42857 5.25V8.89286ZM6 4.28571C5.83178 4.28228 5.6716 4.21304 5.55384 4.09286C5.43609 3.97267 5.37013 3.81112 5.37013 3.64286C5.37013 3.4746 5.43609 3.31304 5.55384 3.19286C5.6716 3.07267 5.83178 3.00343 6 3C6.16822 3.00343 6.3284 3.07267 6.44616 3.19286C6.56391 3.31304 6.62987 3.4746 6.62987 3.64286C6.62987 3.81112 6.56391 3.97267 6.44616 4.09286C6.3284 4.21304 6.16822 4.28228 6 4.28571Z"
        fill={fillStyle || '#03341D'}
      />
    </svg>
  )

  return (
    <SvgIcon
      component={cleanedPaths}
      inheritViewBox
      sx={styles}
      {...otherProps}
    />
  )
}

export default InfoIcon
